import { Component, Input, OnInit } from '@angular/core';
import * as moment from 'moment';
import { PagamentiDTO } from '../../models/pagamento-dto';


@Component({
  selector: 'lib-dati-pagamento',
  templateUrl: './dati-pagamento.component.html',
  styleUrls: ['./dati-pagamento.component.css']
})
export class DatiPagamentoComponent implements OnInit {

  @Input()
  pagamento: PagamentiDTO;
  dataR: string;
  constructor() { }

  ngOnInit(): void {
    this.dataR = this.pagamento.dataEmissione != null ?
    moment(new Date(this.pagamento.dataEmissione)).format("DD/MM/YYYY") : '';
  }


}
